import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M27.36 16.27L20 22L12.63 16.27L11 15L20 8L29 15L27.36 16.27ZM25.74 15L20 10.53L14.26 15L20 19.47L25.74 15ZM12.62 18.81L19.99 24.54L27.37 18.8L29 20.07L20 27.07L11 20.07L12.62 18.81Z",
		fill: "#FFFFFF"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.62 24.01L19.99 29.74L27.37 24L29 25.27L20 32.27L11 25.27L12.62 24.01Z",
		fill: "#FFFFFF"
	})]
});
export default SvgLayers;
